import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { isAxiosError } from 'axios';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/utils/isBrowser.ts
function isBrowser() {
  return typeof window !== "undefined";
}

// src/initNextDatadogLogs.ts
var createNextDatadogLogsConfig = (options) => ({
  clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN || "Not Client Token",
  site: "datadoghq.com",
  service: process.env.NEXT_PUBLIC_DATADOG_APPLICATION,
  env: process.env.NEXT_PUBLIC_DATADOG_ENV,
  version: options == null ? void 0 : options.version,
  forwardErrorsToLogs: false,
  sessionSampleRate: 100,
  telemetrySampleRate: 100
});
var initNextDatadogLogs = (options) => {
  if (!isBrowser()) {
    return;
  }
  const isDev = process.env.NEXT_PUBLIC_MODE === "development";
  const isLocal = process.env.NEXT_PUBLIC_LOCAL_MODE === "true";
  if (isDev && isLocal) {
    return;
  }
  const config = createNextDatadogLogsConfig(options);
  datadogLogs.init(config);
};

// src/utils/excludeErrorMessages.ts
var excludeErrorMessages = (event, errorMessages) => {
  if (event.type === "error") {
    const hasIncludedMessage = errorMessages.some(
      (message) => {
        var _a, _b;
        return (_b = (_a = event.error) == null ? void 0 : _a.message) == null ? void 0 : _b.includes(message);
      }
    );
    if (hasIncludedMessage) {
      return false;
    }
  }
  return true;
};

// src/initNextDatadogRum.ts
var createNextDatadogRumConfig = (options) => {
  var _a, _b;
  return __spreadValues({
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID || "No Application Id",
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN || "No Client Token",
    site: "datadoghq.com",
    service: process.env.NEXT_PUBLIC_DATADOG_APPLICATION,
    env: process.env.NEXT_PUBLIC_DATADOG_ENV,
    version: options == null ? void 0 : options.version,
    sessionSampleRate: (_a = options == null ? void 0 : options.sessionSampleRate) != null ? _a : 3,
    sessionReplaySampleRate: (_b = options == null ? void 0 : options.sessionReplaySampleRate) != null ? _b : 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    allowedTracingUrls: [
      `${process.env.NEXT_PUBLIC_API_DOMAIN}`,
      `${process.env.NEXT_PUBLIC_CDN_DOMAIN}`
    ],
    beforeSend: (options == null ? void 0 : options.beforeSend) ? options.beforeSend : (options == null ? void 0 : options.ignoreErrorMessages) ? (event) => {
      const exceptMessages = (options == null ? void 0 : options.ignoreErrorMessages) || [];
      return excludeErrorMessages(event, exceptMessages);
    } : void 0
  }, options);
};
var initNextDatadogRum = (options) => {
  if (!isBrowser()) {
    return;
  }
  const isDev = process.env.NEXT_PUBLIC_MODE === "development";
  const isLocal = process.env.NEXT_PUBLIC_LOCAL_MODE === "true";
  if (isDev && isLocal) {
    return;
  }
  const config = createNextDatadogRumConfig(options);
  datadogRum.init(config);
  datadogRum.startSessionReplayRecording();
};
var createNuxtDatadogLogsConfig = (options) => ({
  clientToken: process.env.DATADOG_CLIENT_TOKEN || "Not Client Token",
  site: "datadoghq.com",
  service: process.env.DATADOG_APPLICATION,
  env: process.env.DATADOG_ENV,
  version: options == null ? void 0 : options.version,
  forwardErrorsToLogs: false,
  sessionSampleRate: 100,
  telemetrySampleRate: 100
});
var initNuxtDatadogLogs = (options) => {
  if (!isBrowser()) {
    return;
  }
  const isDev = process.env.BUILD === "dev";
  const isLocal = process.env.LOCAL_MODE === "true";
  if (isDev && isLocal) {
    return;
  }
  const config = createNuxtDatadogLogsConfig(options);
  datadogLogs.init(config);
};
var createNuxtDatadogRumConfig = (options) => {
  var _a, _b;
  return __spreadValues({
    applicationId: process.env.DATADOG_APPLICATION_ID || "No Application Id",
    clientToken: process.env.DATADOG_CLIENT_TOKEN || "No Client Token",
    site: "datadoghq.com",
    service: process.env.DATADOG_APPLICATION,
    env: process.env.DATADOG_ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    version: options == null ? void 0 : options.version,
    sessionSampleRate: (_a = options == null ? void 0 : options.sessionSampleRate) != null ? _a : 3,
    sessionReplaySampleRate: (_b = options == null ? void 0 : options.sessionReplaySampleRate) != null ? _b : 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    allowedTracingUrls: [
      `${process.env.API_DOMAIN}`,
      `${process.env.VEHICLE_API_DOMAIN}`,
      `${process.env.CDN_DOMAIN}`
    ],
    defaultPrivacyLevel: "mask-user-input",
    traceSampleRate: 100,
    beforeSend: (options == null ? void 0 : options.beforeSend) ? options.beforeSend : (options == null ? void 0 : options.ignoreErrorMessages) ? (event) => {
      const exceptMessages = (options == null ? void 0 : options.ignoreErrorMessages) || [];
      return excludeErrorMessages(event, exceptMessages);
    } : void 0
  }, options);
};
var initNuxtDatadogRum = (options) => {
  if (!isBrowser()) {
    return;
  }
  const isDev = process.env.BUILD === "dev";
  const isLocal = process.env.LOCAL_MODE === "true";
  if (isDev && isLocal) {
    return;
  }
  const config = createNuxtDatadogRumConfig(options);
  datadogRum.init(config);
  datadogRum.startSessionReplayRecording();
};
function logErrorToDatadogRum(error, options) {
  if (!isAxiosError(error)) {
    logClientErrorToDatadogRum(error, options);
  } else {
    logNetworkErrorToDatadogRum(error, options);
  }
}
function logNetworkErrorToDatadogRum(error, options) {
  var _a, _b, _c, _d, _e;
  datadogRum.addError(error, __spreadValues({
    type: "network",
    statusCode: (_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status,
    resource: (_b = error == null ? void 0 : error.config) == null ? void 0 : _b.url,
    method: (_c = error == null ? void 0 : error.config) == null ? void 0 : _c.method,
    data: (_d = error == null ? void 0 : error.config) == null ? void 0 : _d.data,
    response: (_e = error == null ? void 0 : error.response) == null ? void 0 : _e.data,
    pathname: window.location.pathname,
    href: window.location.href
  }, options));
}
function logClientErrorToDatadogRum(error, options) {
  datadogRum.addError(error, __spreadValues({
    type: "client",
    path: window.location.pathname,
    href: window.location.href
  }, options));
}
var logToDatadog = datadogLogs.logger;
function setDatadogStaff(user) {
  datadogRum.setUser(user);
}

export { initNextDatadogLogs, initNextDatadogRum, initNuxtDatadogLogs, initNuxtDatadogRum, logErrorToDatadogRum, logToDatadog, setDatadogStaff };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.js.map